import { Component, EventEmitter, Input, Output } from '@angular/core';

import { IndividualRecipientReportDataModel } from '../recipient.report.data.model';
import { DistributionReportService } from '../../../../../../Discover/Targeting/components/Distribution/DistributionReport/distribution.report.service';
import { ButtonTypesEnum } from '../../../../../Forms/enums/button-types.enum';
import { DistributionReportStat } from '../../../../model/statisticsReport/distribution-report-stat-api.model';
import { ActionKeys } from '../../../../../Forms/enums/keys.enum';
import { StatTypeChangeInterface } from '../../../../model/statisticsReport/stat-type-change.interface.model';


@Component({
    selector: 'agpr-undesirables-report',
    templateUrl: './undesirables.report.component.html',
    styleUrls: ['./undesirables.report.component.scss', './undesirables.report.component.compact.scss'],
    providers: [{
            provide: DistributionReportService,
            useClass: DistributionReportService
        }],
    standalone: false
})
export class UndesirablesReportComponent {

    readonly buttonTypes = ButtonTypesEnum;
    readonly statTypes = DistributionReportStat;

    @Input() data: IndividualRecipientReportDataModel;
    @Input() compactDisplay: boolean = false;
    @Input() selectedType: DistributionReportStat;
    @Input() openTracking: boolean = true;
    @Input() selectedIndividualRecipient: IndividualRecipientReportDataModel;

    @Output() statTypeSelected: EventEmitter<StatTypeChangeInterface> = new EventEmitter<StatTypeChangeInterface>();

    selectStatType(statType: DistributionReportStat) {
        this.selectedType = statType;
        this.statTypeSelected.next({
            statType: this.selectedType,
            data: this.data
        });
    }

    statCardKeydown(event: KeyboardEvent, statType: DistributionReportStat) {
        if (event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE) {
            this.selectStatType(statType);
        }
    }
}
